var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgScrollToTop = function SvgScrollToTop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "700pt",
    height: "700pt",
    viewBox: "0 0 700 700",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M161.129 52.406v73.54h377.748v-73.54zm0 293.85h152.085v161.33h73.606v-161.33h152.057L349.994 157.377z",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 11.2
  })));
};

export default SvgScrollToTop;